import { gql } from '@apollo/client';

export const LEAD_FORM_QUERY = gql`
  mutation postMutation(
    $name: String!
    $email: String!
    $phone: String!
    $message: String
    $source: String!
    $recaptcha: String!
  ) {
    sendLeadCaptureEmail(
      name: $name
      email: $email
      phone: $phone
      message: $message
      source: $source
      recaptcha: $recaptcha
    ) {
      status
      message
    }
  }
`;
